{
  "unified": {
    "cdp": {
      "stats": {
        "collegesNoun": "Institutions"
      },
      "favouriteStudyEmpty": "You haven’t saved any study matches yet. Explore institutions and courses and save the ones you like.",
      "favouriteCareersHighlight": "favourite",
      "favouriteCareersEmpty": "You haven’t favourited any careers yet. Tap the heart on a career you like and it’ll show up here.",
      "favouriteStudyHeading": "Your favourite study matches",
      "storyIntro": "You’ve been busy on Anyway discovering what drives you. Here’s what we’ve learnt so far…",
      "persona": {
        "tags": {
          "C": "Organised"
        }
      }
    },
    "allowAnimation": "Allow animations",
    "home": "home",
    "learnMore": "Learn more",
    "headUpPhoneRewards": "Heads up: You’ll need to add your number to grab your rewards",
    "inProgress": "In progress:",
    "onboarding": {
      "welcome": "Just quickly, can I get some information from you?",
      "email": "Just quickly, can I get some information from you?",
      "otp": "Thanks! I just sent you an email with a pin. Can you put that in for me?",
      "termsAndConditions": "This is your first time so please tick this box so I can create your account",
      "skip": "Skip",
      "engineering": "Engineering",
      "soundDesign": "Sound Design",
      "gaming": "Gaming",
      "hiImBlinky": "Hi, I'm Blinky.",
      "letsStartExploring": "Let's start exploring",
      "toStartExploring": "to start exploring!",
      "options": "Options.",
      "sometimesItsHardTo": "Sometimes it's hard to",
      "knoWhichWayToGo": "know which way to go...",
      "butThatsWhyImHere": "But that's why I'm here!",
      "letsFindYourThing": "Let's find your thing.",
      "andGetYouPaidForIt": "and get you paid for it"
    },
    "activity": {
      "badge": {
        "displayedSkill": "You've displayed a new skill"
      },
      "overview": {
        "by": "Sponsored by {name}",
        "learningObjectives": "What you will learn",
        "skills": "Skills in this collection",
        "start": "Start",
        "continue": "Continue",
        "prize": {
          "tagMissingVerification": "You need to verify your phone number to be entered into the prize giveaway"
        },
        "tabs": {
          "learningOutcomes": "What you will learn",
          "skills": "Skills in this collection",
          "prizeEntry": "Prize entry"
        }
      },
      "completion": {
        "completedHeading": "Well done completing {name}!",
        "continueJourney": "Continue your journey",
        "chooseDifferentStory": "Choose a different story",
        "storiesCompleted": "stories completed",
        "skillsDisplayed": "Skills you've displayed",
        "youveEarned": "You've earned:",
        "coins": "coins",
        "bonusCoins": "bonus coins",
        "totalCoins": "total coins",
        "saveCoins": "Save Coins",
        "saveProgress": "Save progress",
        "greatJob": "Great job completing this activity!",
        "completionHeadingCollection": "Congratulations on completing the {assetName} on {collectionName}!",
        "completionHeadingStandalone": "Congratulations on completing the {assetName}!",
        "reCompletionHeadingCollection": "Congratulations on re-doing the {assetName} on {collectionName}!",
        "reCompletionHeadingStandalone": "Congratulations on re-doing the {assetName}!",
        "partialCount": "{completed}/{total} completed",
        "partialUnlockMessage": "Complete all {total} to unlock the badge and get bonus coins.",
        "enterPrizeDraw": "Enter prize draw",
        "skipPrizeDraw": "Skip prize draw",
        "wellDone": "Well done!",
        "prize": {
          "confirmHeading": "Confirm your entry",
          "confirmBody": "By clicking on the button below you are accepting our {termsLink} for the {prizeName}.",
          "confirmTermsLink": "terms and conditions",
          "confirmButton": "Confirm entry",
          "cancelButton": "Cancel",
          "confirmedHeading": "Nice! You're in the prize draw!",
          "confirmedBody": "Your entry for the {prizeName} is locked in.",
          "phoneSkippedHeading": "You're almost done",
          "phoneSkippedBody": "We've saved your entry, but you'll need to verify your number later to lock it in.",
          "phoneSkippedSubtext": "You can do it at anytime from your profile page.",
          "cancelledHeading": "All good! Maybe next time",
          "cancelledBody": "You skipped the prize draw this time. You can always enter the next one."
        },
        "firstBadge": {
          "title": "You earned your first badge! 🎉",
          "subtitle": "Nice one. Explore your badges to see what you've earned and what you can unlock next.",
          "exploreCta": "Explore badges",
          "dismissCta": "Maybe later"
        }
      },
      "mentor": {
        "storyCompleted": "completed",
        "pageOfTotal": "Page {current} of {total}"
      },
      "sentiment": {
        "feedbackSubmitted": "Thank you for your feedback!",
        "feedbackFailed": "Failed to submit feedback. Please try again.",
        "howDidYouFind": "How did you find {name}?",
        "positive": "Loved it",
        "neutral": "Don't care",
        "negative": "Didn't like it",
        "skip": "Skip",
        "submit": "Submit"
      },
      "closeConfirmation": {
        "title": "Are you sure you want to leave?",
        "description": "All your progress will be lost",
        "confirm": "Yes, leave",
        "cancel": "Cancel"
      },
      "notFound": {
        "heading": "Oops! I can't seem to find that content right now.",
        "description": "This activity may have been moved or is temporarily unavailable.",
        "goBack": "Go back"
      }
    },
    "activities": {
      "singleInstitution": {
        "funFacts": "Fun Facts"
      },
      "multipleInstitutions": {
        "title": "Explore Institutions"
      },
      "singleJob": {
        "personalised": "Personalised"
      }
    },
    "landing": {
      "learn": "Learn",
      "logIn": "Log in",
      "placeholderTitle": "Placeholder landing page",
      "disclosure": "Promotions may involve games of skill or chance. Details, including how winners are determined, are provided in the applicable promotion terms.",
      "activeCampaign": {
        "inPartnershipWith": "Reward brought to you by",
        "cta": "Get Started",
        "terms": "Rewards, competitions and promotions are subject to specific terms and conditions, including how winners are determined.",
        "earnableCoins": "Earn {coins} coins"
      },
      "makeAPlan": {
        "blinkyMessage": "Hey! I'm Blinky, your personalised career coach. Making life decisions can be tough, but I'm here to help you through it. Let's have a chat!"
      },
      "careers": {
        "graduatesFact": "Graduates with clear career goals see their salaries grow by 88% within 10 years"
      }
    },
    "careers": {
      "title": "Careers",
      "noIndustriesFound": "No industries found",
      "noIndustriesPublished": "No industries published",
      "showMore": "Show more",
      "hero": {
        "scroll": "Scroll",
        "spotlightImages": {
          "audioEngineer": "Audio Engineer",
          "astronaut": "Astronaut",
          "streamer": "Streamer"
        }
      }
    },
    "about": {
      "nav": {
        "ourStory": "Our Story",
        "approach": "Approach",
        "partners": "Partners",
        "team": "Team"
      },
      "partnerWithUs": "Partner with us"
    },
    "partners": {
      "nav": {
        "theProblem": "The problem",
        "ourSolutions": "Our solutions",
        "partnerships": "Partnerships"
      },
      "contactUs": "Contact us"
    },
    "learn": {
      "welcomeMessage": "Welcome! I'm Blinky.",
      "loginAriaLabel": "Login",
      "logoAlt": "Anyway logo",
      "popularTopics": "Popular Topics",
      "popularChannels": "Popular Channels",
      "exploreTopics": "Explore Topics",
      "stories": "Stories",
      "experiences": "Experiences",
      "faqs": "FAQs",
      "trending": {
        "heading": "Trending experiences",
        "description": "Try out some of our unique partner experiences and get paid with coins and rewards."
      },
      "testimonials": {
        "card1": "Your site gives me so much comfort. Knowing all my experiences are completely normal y'know? It's not just the kind of generic stuff every adult drills into us - it really calms the whole school/life thing down. Super refreshing!",
        "card3": "Your website has changed my mindset on life after school - thank you so much for the service you provide!"
      },
      "spotlight": {
        "heading": "How Anyway works",
        "card1Title": "Explore your future, your way.",
        "card1Description": "Follow your interests across careers, skills and real-world pathways.",
        "card2Title": "Experience a wide range of careers.",
        "card2Description": "Explore careers through interactive stories and earn coins and rewards.",
        "card3Title": "Get paid. Win prizes.",
        "card3Description": "Cash out your coins and complete campaign drops for a shot at prizes."
      },
      "pages": {
        "explore": {
          "errors": {
            "loadFailed": "Couldn't load the catalogue. Please refresh."
          }
        }
      }
    },
    "partnerWithUs": {
      "heading": "Partner with us",
      "subheading": "Interested in working together?",
      "body": "We partner with brands, educators, industry, and governments who care about helping young people find their thing and build better futures. Let's create something great together.",
      "learnMore": "Learn more",
      "videoTitle": "Anyway Mission Statement"
    },
    "footer": {
      "copyright": "© 2026 ANYWAY"
    },
    "common": {
      "back": "Back",
      "by": "By",
      "close": "Close",
      "min": "min",
      "minShort": "m",
      "scrollLeft": "Scroll left",
      "scrollRight": "Scroll right",
      "scrollableList": "Scrollable list",
      "contentRecommendations": "Content recommendations",
      "jobRecommendations": "Job recommendations",
      "institutionRecommendations": "Institution recommendations",
      "actionRecommendations": "Action recommendations",
      "carousel": {
        "navigation": "Carousel navigation",
        "slideOf": "Slide {current} of {total}",
        "slide": "slide",
        "previousSlide": "Previous slide",
        "nextSlide": "Next slide",
        "pauseCarousel": "Pause carousel",
        "playCarousel": "Play carousel"
      }
    },
    "toast": {
      "closeNotification": "Close notification",
      "defaultTitle": {
        "success": "Success",
        "error": "Error",
        "warning": "Warning"
      }
    },
    "seo": {
      "landing": {
        "title": "Career Advice, AI Career Coach & Learn & Earn | Anyway",
        "description": "Anyway helps students explore careers, get personalised AI career coaching, make a plan and earn rewards while figuring out what fits.",
        "ogTitle": "Explore careers, make a plan and earn rewards | Anyway",
        "ogDescription": "Anyway helps young people explore careers, get personalised AI career coaching and earn rewards while building a plan for what comes next."
      },
      "learn": {
        "title": "Learn & Earn | Explore Careers & Earn Rewards | Anyway",
        "description": "Explore careers and life skills, complete activities, earn coins and unlock rewards, experiences and campaign entries with Anyway Learn & Earn.",
        "ogTitle": "Learn & Earn with Anyway",
        "ogDescription": "Complete activities, explore future pathways, earn coins and unlock rewards, experiences and competitions with Anyway."
      },
      "about": {
        "description": "Learn how Anyway combines engaged learning and AI-powered 1:1 career coaching to help young people explore options, build confidence and plan life after school.",
        "ogTitle": "About Anyway: helping young people find their thing",
        "ogDescription": "See Anyway's mission, story and impact across career learning, AI coaching and partnerships with educators, government and industry."
      },
      "partners": {
        "title": "Partners | Anyway",
        "description": "Partner with Anyway to connect your brand with the next generation of talent."
      },
      "careers": {
        "title": "Career Advice & AI Career Coach for Students | Anyway",
        "description": "Explore industries, understand your strengths and build a personal career plan with Anyway's AI career coach.",
        "ogTitle": "Find a career that actually fits you | Anyway",
        "ogDescription": "Understand your strengths, explore industries and chat with Anyway's AI career coach to build a career plan that fits you."
      },
      "explore": {
        "description": "Pick a category and explore industries, career advice, and every university, TAFE and training provider across {region}.",
        "ogDescription": "Pick a category and explore industries, career advice, and every university, TAFE and training provider across {region}."
      },
      "exploreIa": {
        "description": "Pick a category and explore industries, career advice, and every university, TAFE and training provider across {regionInProse}."
      },
      "login": {
        "title": "Sign up | Anyway"
      },
      "terms": {
        "title": "Terms and Conditions | Anyway",
        "description": "Read the Anyway Terms and Conditions."
      },
      "privacyPolicy": {
        "title": "Privacy Policy | Anyway",
        "description": "Read the Anyway Privacy Policy."
      },
      "institutionGuide": {
        "hub": {
          "title": "Universities, TAFEs & Training Providers in {region} | Anyway",
          "description": "Browse every university, TAFE, college and training provider in {region} by name, state and institution type.",
          "ogDescription": "Every university, TAFE, college and training provider in {region}, searchable by name, state and institution type."
        }
      },
      "faqSection": {
        "title": "{section} | Anyway"
      }
    },
    "nav": {
      "home": "Home",
      "schools": "Schools",
      "account": "Account",
      "badges": "Badges",
      "rewardStore": "Rewards",
      "saved": "Saved",
      "logout": "Logout",
      "learn": "Learn",
      "coachAdvice": "Coach",
      "careerAdvice": "Career advice",
      "about": "About us"
    },
    "wallet": {
      "title": "Badges",
      "tabs": {
        "badges": "Badges",
        "skills": "Skills"
      },
      "skills": {
        "title": "Skills",
        "subtitle": "{count} / {total} skills earned",
        "empty": "No skills available yet"
      },
      "sponsored": {
        "title": "Sponsored badges",
        "subtitle": "Partnered content for you",
        "empty": "No partnered content available"
      },
      "completedBadges": "{count} Badges",
      "badgeList": {
        "title": "More badges you can earn",
        "subtitle": "Earned {count} / {total} badges",
        "empty": "No badges earned yet",
        "showMore": "Show more"
      },
      "detail": {
        "coinsAvailable": "Coins available",
        "associatedSkills": "Associated skills",
        "getBadge": "Get Badge",
        "continue": "Continue",
        "completed": "Completed",
        "by": "Sponsored by {name}",
        "back": "Back to wallet",
        "prize": "Prize Entry Available"
      }
    },
    "coins": {
      "cashout": "Redeem"
    },
    "schools": {
      "form": {
        "schoolName": {
          "label": "School name",
          "placeholder": "Enter school name",
          "required": "School name is required"
        },
        "firstName": {
          "label": "First name",
          "placeholder": "Enter first name",
          "required": "First name is required"
        },
        "lastName": {
          "label": "Last name",
          "placeholder": "Enter last name",
          "required": "Last name is required"
        },
        "email": {
          "label": "Email",
          "placeholder": "Enter your email",
          "required": "Email is required",
          "invalid": "Enter a valid email address"
        },
        "phoneNumber": {
          "label": "Phone number"
        },
        "state": {
          "label": "State/Territory",
          "placeholder": "Select state/territory",
          "required": "State/Territory is required"
        },
        "submit": "Submit enquiry",
        "success": "Thank you for your enquiry! We'll be in touch soon."
      },
      "thankYou": {
        "heading": "Thank you!",
        "description": "Your enquiry has been submitted. We'll be in touch soon.",
        "submitAnother": "Submit another enquiry"
      }
    },
    "campaigns": {
      "termsAndConditions": {
        "heading": "Terms and Conditions"
      },
      "blockedReasons": {
        "campaignDatesNotValid": "Campaign is not valid",
        "campaignNotStarted": "Campaign has not started yet",
        "campaignEnded": "Campaign has ended",
        "completeExperienceRequired": "Complete this experience to unlock this prize draw."
      }
    },
    "referralFaqs": {
      "heading": "Referral FAQs"
    },
    "rewardsStore": {
      "prizes": {
        "earnableCoins": "{coins} coins"
      }
    },
    "jobCandidates": {
      "empty": {
        "features": {
          "buildPlan": {
            "description": "Add courses and institutions to create your personalised pathway."
          }
        }
      },
      "routeDeepDive": {
        "slots": {
          "searchInstitution": "Search universities, TAFEs, colleges",
          "institutionPromptBody": "Search universities, TAFEs and colleges.",
          "coursePromptBody": "Try a subject like nursing, or a qualification like a diploma.",
          "course": "Course",
          "addCourse": "Shortlist a course",
          "addAnotherCourse": "Add another course",
          "searchCourse": "Search course names and qualifications"
        },
        "personaliseHint": "Add your institution and course to personalise this step.",
        "steps": {
          "courseInstitution": "Course + institution"
        }
      },
      "glance": {
        "routes": {
          "degreeFirst": "Straight to uni",
          "subdegreeFirst": "Diploma first"
        }
      },
      "compare": {
        "decision": {
          "description": "Weigh up this route, then tell me what you reckon."
        },
        "weighUp": {
          "openRoute": "Weigh up {route}"
        }
      },
      "row": {
        "courses": "{count} course | {count} courses"
      },
      "buckets": {
        "plans": {
          "description": "Plans you’ve built with courses and institutions."
        }
      }
    },
    "results": {
      "raisec": {
        "parts": {
          "C": {
            "description": "Organised and detail-oriented, you bring structure and reliability."
          },
          "E": {
            "description": "Persuasive and driven, energised by leading and taking initiative."
          }
        }
      },
      "myersBriggs": {
        "parts": {
          "E": {
            "description": "Energised by people and the buzz of being around others."
          },
          "T": {
            "description": "Decides with logic, weighing things up objectively."
          }
        }
      },
      "superWorkValues": {
        "parts": {
          "management": {
            "description": "Wanting work where you lead and organise others."
          }
        }
      },
      "selfEfficacy": {
        "parts": {
          "emerging-persuasion": {
            "title": "Emerging: Fuelled by Encouragement",
            "shortTitle": "Fuelled by Encouragement"
          },
          "emerging-mastery": {
            "description": "Your self-belief is just getting started. Small wins from having a go will build it fastest."
          }
        }
      }
    },
    "institution": {
      "topVibes": {
        "title": "About the neighbourhood"
      },
      "numbers": {
        "vocational": "VET / vocational",
        "postgraduate": "Postgraduate",
        "acrossFaculties": "Across {count} faculty and study area | Across {count} faculties and study areas",
        "courseMix": "Course mix",
        "courseMixAriaLabel": "Course mix by qualification level",
        "totalCourses": "{count} course | {count} courses",
        "popularCourses": "Most popular courses"
      },
      "hero": {
        "exploreCourses": "Explore courses"
      },
      "topOccupations": {
        "subtitle": "Where a qualification from {name} can take you"
      },
      "costs": {
        "courseFee": "Avg course fee"
      }
    },
    "considerations": {
      "scoreInfoDialogBody": "Career Clarity is the measure of your overall progress towards making a considered career decision. The higher this score, the more thoughtfully you've explored your options, and the more equipped you are to make a plan for your future.",
      "profile": {
        "addNameSubtext": "To personalise your experience"
      }
    },
    "feedbackSurvey": {
      "lesson": {
        "subjectEngagement": "I am more motivated to engage in this subject"
      }
    },
    "institutionGuide": {
      "hub": {
        "pitch": "Every university, TAFE, college and training provider across {region}, in one place."
      },
      "filters": {
        "state": "State or territory"
      }
    },
    "explore": {
      "categories": {
        "institutions": {
          "description": "Universities, TAFEs, colleges and training providers across {region}."
        }
      }
    },
    "planIa": {
      "portfolioTile": {
        "description": "Keep track of the things you’ve done, learnt and achieved along the way."
      }
    },
    "clarityIa": {
      "score": {
        "description": "Career Clarity measures your progress towards making an informed career decision. The higher your score, the more you’ve explored your options and the better prepared you are to plan your future."
      }
    },
    "faq": {
      "sections": {
        "general": "General FAQs",
        "referral": "Referral FAQs",
        "cashout": "Cashout FAQs",
        "westpac50100": "Westpac 50–100 FAQs",
        "schoolsLanding": "Schools teachers landing FAQs",
        "schoolsLeadersLanding": "Schools leaders landing FAQs",
        "schoolsAdvisorsLanding": "Schools advisors landing FAQs",
        "campaign": "Campaign FAQs"
      },
      "empty": "There are no questions in this section yet.",
      "publicPageToggle": "Enable standalone public page",
      "publicPageHint": "Published at {url}",
      "publicPageHidden": "Standalone page is hidden",
      "publicPageAlwaysOn": "The General section’s standalone page is always on",
      "shownOn": "Shown on: {surfaces}",
      "surfaces": {
        "general": "the Learn landing page FAQ block, the campaign landing page when the active campaign has no FAQs of its own (first 5), and the standalone public page",
        "cashout": "the Rewards page cashout tab and the cashout FAQ modal, plus the standalone public page when enabled",
        "referral": "the Rewards page referrals tab, plus the standalone public page when enabled",
        "westpac50100": "the Rewards page Westpac tab and the Westpac cashout modal (deal ended), plus the standalone public page when enabled",
        "schoolsLanding": "the schools teachers landing page, plus the standalone public page when enabled",
        "schoolsLeadersLanding": "the schools leaders landing page, plus the standalone public page when enabled",
        "schoolsAdvisorsLanding": "the schools advisors landing page, plus the standalone public page when enabled",
        "campaign": "campaign pages only, edited in the campaign editor"
      }
    }
  },
  "content": {
    "articles": {
      "editor": {
        "fields": {
          "quizResultTypeAccent": "Accent colour"
        }
      }
    },
    "loginAttempts": {
      "nav": "Login attempts",
      "title": "Login attempts",
      "dateTimeFormat": "D MMM YYYY, h:mm:ss a",
      "field": {
        "label": "Look up a login attempt",
        "placeholder": "Reference code or email",
        "submit": "Look up"
      },
      "table": {
        "code": "Reference code",
        "started": "Started",
        "outcome": "Outcome",
        "reason": "Reason",
        "providerIds": "Provider IDs",
        "connection": "Connection",
        "identity": "Identity",
        "account": "Account"
      },
      "methods": {
        "otp": "Email code",
        "password": "Password",
        "google": "Google",
        "microsoft": "Microsoft",
        "clever": "Clever",
        "fakeClever": "Clever (fake)"
      },
      "surfaces": {
        "student": "Student login",
        "teacher": "Educator login",
        "admin": "Admin login"
      },
      "methodOnSurface": "{method} · {surface}",
      "statuses": {
        "started": "In progress",
        "awaitingProof": "Waiting for email code",
        "proven": "Email proven, not finished",
        "failed": "Failed",
        "succeeded": "Succeeded"
      },
      "reasons": {
        "notAvailable": "Not available",
        "loginsDisabled": "Logins switched off",
        "connectionPaused": "Connection paused",
        "notSetUp": "Not set up",
        "needsAttention": "Needs attention",
        "notEnrolled": "Not enrolled here",
        "unauthorizedUser": "Refused by the provider",
        "loginExpired": "Login expired",
        "signInFailed": "Sign-in failed",
        "proofFailed": "Email proof failed"
      },
      "credentialReasons": {
        "invalidCode": "Wrong or expired code",
        "unconfirmedAddress": "Address not confirmed",
        "addressClaimed": "Claimed by another account",
        "invalidCredentials": "Wrong password, or no account",
        "signInExpired": "Sign-in expired before the password",
        "schoolAccountEmail": "School email, sent to the school’s site",
        "classroomNotVerified": "Invite is to an unverified classroom"
      },
      "flows": {
        "existingRole": "Signed in",
        "newRole": "Sent to sign-up",
        "mfaChallengeRequired": "Waiting for second factor",
        "mfaEnrolmentRequired": "Waiting for second factor setup",
        "passwordRequired": "Code passed, waiting for password",
        "accountChoiceRequired": "Waiting for account choice"
      },
      "steps": {
        "transactionStart": "Step 0 · Start",
        "transactionLookup": "Step 1 · Return from provider",
        "codeExchange": "Step 2 · Code exchange",
        "connection": "Step 4 · Connection",
        "identity": "Step 5 · Identity",
        "role": "Step 6 · Role"
      },
      "noConnection": "None",
      "schoolsViewNeeded": "Schools view needed",
      "identityStatuses": {
        "linked": "Linked",
        "pending": "Pending proof",
        "held": "Held"
      },
      "proven": "Proven",
      "notProven": "Not proven",
      "firstSeen": "First seen {time}",
      "lastSeen": "Last seen {time}",
      "never": "not recorded",
      "holdsTab": "Holds",
      "noIdentity": "None",
      "noAccount": "No account",
      "empty": "No login attempts match",
      "userCard": {
        "title": "Login attempts",
        "empty": "No login attempts in the last 90 days"
      }
    }
  }
}
